import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating a view
import Filter from 'views/reports/assignmentQuota/filter'; // Importing Filter component for report filtering
import Table from 'views/reports/assignmentQuota/table'; // Importing Table component for displaying report data
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the assignment quota view.
 * @extends JetView
 */
export default class assignmentQuotaView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service for translations
        const _ = this.app.getService('locale')._;
        // Get the current theme configuration
        const theme = this.app.config.theme;
        // Get the current screen size configuration
        const screen = this.app.config.size;
        // Define the configuration for the right panel
        const right = {
            type: 'wide',
            rows: [],
        };
        // Define the toolbar configuration
        const toolbar = {
            view: 'toolbar', // Specify the view type as 'toolbar'
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Define the columns within the toolbar
                {
                    view: 'select', // Dropdown selection for page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the select element
                    on: {
                        // Event handler for when the selection changes
                        onChange: function () {
                            // Update the pager size based on the selected value
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Convert selected value to number
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch
                },
                {
                    view: 'richselect', // Rich select for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // Unique identifier for the export select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text for the select
                    options: [
                        // Options for export format
                        { id: '1', value: 'Excel' }, // Option for Excel export
                        { id: '2', value: 'PDF' }, // Option for PDF export
                    ],
                    on: {
                        // Event handler for when the export format changes
                        onChange: function (value) {
                            // Check if the selected value is for Excel export
                            if (value == 1) {
                                var table = $$('datatable'); // Reference to the datatable
                                // Loop through columns to remove format for export
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for exportable columns
                                    }
                                }
                                // Trigger export data event for Excel
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + // Check if there are data
                                            _(
                                                'Reporte de transferencias de saldo Recibidas', // Report title
                                            ),
                                        TypeReport: 'Excel', // Specify report type
                                    },
                                ]);
                                // Export the datatable to Excel
                                webix.toExcel(table, {
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            }) // Format the filename with current date
                                            .replace(
                                                /^(\d{4})-(\d{2})-(\d{2})$/g,
                                                '$3/$2/$1', // Change date format to DD/MM/YYYY
                                            )
                                            .replace(/[\/:]/g, '_') // Replace slashes and colons with underscores
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _(
                                            'Reporte de transferencias de saldo Recibidas', // Append report title
                                        ),
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                });
                            } else {
                                // Check if the selected value is for PDF export
                                if (value == 2) {
                                    // Trigger export data event for PDF
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _(
                                                    'Reporte de transferencias de saldo Recibidas', // Report title
                                                ),
                                            TypeReport: 'PDF', // Specify report type
                                        },
                                    ]);
                                    // Export the datatable to PDF
                                    webix.toPDF($$('datatable'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                }) // Format the filename with current date
                                                .replace(
                                                    /^(\d{4})-(\d{2})-(\d{2})$/g,
                                                    '$3/$2/$1', // Change date format to DD/MM/YYYY
                                                )
                                                .replace(/[\/:]/g, '_') // Replace slashes and colons with underscores
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _(
                                                'Reporte de transferencias de saldo Recibidas', // Append report title
                                            ),
                                        autowidth: true, // Enable auto width for PDF
                                        ignore: { detailTittle: true }, // Ignore detail title in export
                                    });
                                }
                            }
                            // Reset the export select value
                            $$('Export').setValue('');
                        }.bind(this), // Bind the context to the event handler
                    },
                },
            ],
        };
        /**
         * Toolbar configuration object for exporting data.
         * @type {Object}
         */
        const toolbar2 = {
            view: 'toolbar', // Defines the view type as a toolbar
            id: 'toolbar2', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Array of column configurations within the toolbar
                {},
                {
                    view: 'richselect', // Dropdown selection for export options
                    name: 'Export', // Name of the select input
                    id: 'Export2', // Unique identifier for the select input
                    width: 120, // Width of the select input
                    placeholder: _('Exportar'), // Placeholder text for the select input
                    options: [
                        // Options available in the dropdown
                        { id: '1', value: 'Excel' }, // Option for exporting to Excel
                        { id: '2', value: 'PDF' }, // Option for exporting to PDF
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for when the selected option changes
                            if (value == 1) {
                                // Check if the selected option is Excel
                                var table = $$('treetable'); // Get the reference to the tree table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        // Check if the column has an export type
                                        delete table.config.columns[j].format; // Remove the format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export data event
                                    {
                                        NameReport:
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) + // Report name based on data availability
                                            _('Reporte de transferencias de saldo Recibidas'), // Report description
                                        TypeReport: 'Excel', // Type of report
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export the table to Excel
                                    filename:
                                        'Virtualsoft - ' + // Filename prefix
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            }) // Current date and time
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Format date
                                            .replace(/[\/:]/g, '_') // Replace slashes and colons
                                            .toUpperCase() + // Convert to uppercase
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) + // Append data availability message
                                        _('Reporte de transferencias de saldo Recibidas'), // Append report description
                                    footer: false, // Do not include footer in the export
                                });
                            } else {
                                if (value == 2) {
                                    // Check if the selected option is PDF
                                    this.app.callEvent('export:data', [
                                        // Trigger export data event
                                        {
                                            NameReport:
                                                ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) + // Report name based on data availability
                                                _('Reporte de transferencias de saldo Recibidas'), // Report description
                                            TypeReport: 'PDF', // Type of report
                                        },
                                    ]);
                                    webix.toPDF($$('treetable'), {
                                        // Export the table to PDF
                                        filename:
                                            'Virtualsoft - ' + // Filename prefix
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                }) // Current date and time
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Format date
                                                .replace(/[\/:]/g, '_') // Replace slashes and colons
                                                .toUpperCase() + // Convert to uppercase
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) + // Append data availability message
                                            _('Reporte de transferencias de saldo Recibidas'), // Append report description
                                        autowidth: true, // Automatically adjust width
                                        footer: false, // Do not include footer in the export
                                    });
                                }
                            }
                            $$('Export2').setValue(''); // Reset the select input value
                        }.bind(this), // Bind the context to the event handler
                    },
                },
            ],
        };
        const left = {
            /**
             * CSS class for the left panel.
             * @type {string}
             */
            css: 'int-left',

            /**
             * Array of rows to be displayed in the left panel.
             * @type {Array<Object>}
             */
            rows: [
                {
                    /**
                     * Defines a toolbar view.
                     * @type {string}
                     */
                    view: 'toolbar',

                    /**
                     * CSS class applied to the toolbar.
                     * @type {string}
                     */
                    css: theme,

                    /**
                     * Elements contained within the toolbar.
                     * @type {Array<Object>}
                     */
                    elements: [
                        {
                            /**
                             * Defines a label element.
                             * @type {string}
                             */
                            view: 'label',

                            /**
                             * Label text based on screen size.
                             * @type {string}
                             */
                            label:
                                screen == 'small'
                                    ? _('Transferencias recibidas') // Label for small screens
                                    : _(
                                          'Reporte de transferencias de saldo Recibidas', // Label for larger screens
                                      ),
                        },
                        {
                            /**
                             * Defines a wide button for search functionality.
                             * @type {string}
                             */
                            type: 'wide',

                            /**
                             * CSS class for the button.
                             * @type {string}
                             */
                            css: 'close-bottom',

                            /**
                             * ID for the search button.
                             * @type {string}
                             */
                            id: 'button-search',

                            /**
                             * Columns contained within the button.
                             * @type {Array<Object>}
                             */
                            cols: [
                                {
                                    /**
                                     * Defines an icon element for the search action.
                                     * @type {string}
                                     */
                                    view: 'icon',

                                    /**
                                     * Icon class for the search icon.
                                     * @type {string}
                                     */
                                    icon: 'wxi-search',

                                    /**
                                     * Bottom margin for the icon.
                                     * @type {number}
                                     */
                                    bottom: 20,

                                    /**
                                     * Right margin for the icon.
                                     * @type {number}
                                     */
                                    right: 35,

                                    /**
                                     * Width of the icon.
                                     * @type {number}
                                     */
                                    width: 30,

                                    /**
                                     * Height of the icon.
                                     * @type {number}
                                     */
                                    height: 30,

                                    /**
                                     * Click event handler to show the filter popup.
                                     * @function
                                     */
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                        {
                            /**
                             * Defines another wide button for closing functionality.
                             * @type {string}
                             */
                            type: 'wide',

                            /**
                             * CSS class for the button.
                             * @type {string}
                             */
                            css: 'close-bottom',

                            /**
                             * Columns contained within the button.
                             * @type {Array<Object>}
                             */
                            cols: [
                                {
                                    /**
                                     * Defines an icon element for the close action.
                                     * @type {string}
                                     */
                                    view: 'icon',

                                    /**
                                     * Icon class for the close icon.
                                     * @type {string}
                                     */
                                    icon: 'wxi-close',

                                    /**
                                     * Bottom margin for the icon.
                                     * @type {number}
                                     */
                                    bottom: 20,

                                    /**
                                     * Right margin for the icon.
                                     * @type {number}
                                     */
                                    right: 35,

                                    /**
                                     * Width of the icon.
                                     * @type {number}
                                     */
                                    width: 30,

                                    /**
                                     * Height of the icon.
                                     * @type {number}
                                     */
                                    height: 30,

                                    /**
                                     * Click event handler to navigate to the dashboard.
                                     * @function
                                     */
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                /**
                 * Reference to the Filter component.
                 * @type {Object}
                 */
                Filter,

                /**
                 * Reference to the Table component.
                 * @type {Object}
                 */
                Table,

                /**
                 * Reference to the first toolbar component.
                 * @type {Object}
                 */
                toolbar,

                /**
                 * Reference to the second toolbar component.
                 * @type {Object}
                 */
                toolbar2,
            ],
        };
        // Initialize the Webix UI in full screen mode
        webix.ui.fullScreen();

        // Return an object representing a Webix form configuration
        return {
            // Unique identifier for the form
            id: 'a5',

            // Type of the form, 'clean' indicates no default styling
            type: 'clean',

            // View type of the component, in this case, a form
            view: 'form',

            // Enable vertical scrolling for the form
            scroll: 'y',

            // Define the layout of the form using rows
            rows: [
                {
                    // Responsive property to adjust layout based on screen size
                    responsive: 'a5',

                    // Type of the row, 'wide' indicates a wider layout
                    type: 'wide',

                    // Define columns within the row, 'left' is a variable representing a column configuration
                    cols: [left],
                },
            ],
        }; // Placeholder for the view's configuration content
    }

    /**
     * Initializes the view and its components.
     * This method is called after the view is created.
     */
    init() {
        // Waits for the Webix UI to be ready before executing the function
        webix.ready(function () {
            // Checks if the screen dimensions are less than 500 pixels
            if (screen.width < 500 || screen.height < 500) {
                // Retrieves child views of the 'toolbar' component
                var childs = $$('toolbar').getChildViews();
                // Removes the third child view from the 'toolbar'
                $$('toolbar').removeView(childs[2]);
                // Defines the 'group' property of 'pagerA' to 1
                $$('pagerA').define('group', 1);
            }
            // Checks if the screen dimensions are greater than 500 pixels
            if (screen.width > 500 && screen.height > 500) {
                // Hides the 'button-search' component
                $$('button-search').hide();
            }
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
